var routes = [{
  path: '/',
  component: function component() {
    return import('pages/Login.vue');
  }
}, {
  path: '/',
  component: function component() {
    return import('layouts/MainLayout.vue');
  },
  children: [{
    path: '/scripts-integration',
    name: 'scripts',
    component: function component() {
      return import('pages/ScriptsIntegration.vue');
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/permissions-manager',
    name: 'permissions-manager',
    component: function component() {
      return import('pages/PermissionsManager.vue');
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/financial-release',
    name: 'financial-release',
    component: function component() {
      return import('pages/FinancialRelease.vue');
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/import-spreadsheet',
    name: '/import-spreadsheet',
    component: function component() {
      return import('pages/ImportSpreadsheet.vue');
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/export-spreadsheet',
    name: '/export-spreadsheet',
    component: function component() {
      return import('pages/ExportSpreadsheet.vue');
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/register-export-group',
    name: '/register-export-group',
    component: function component() {
      return import('pages/RegisterExportGroup.vue');
    },
    meta: {
      requiresAuth: true
    }
  }]
}];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: function component() {
      return import('pages/Error404.vue');
    }
  });
}
export default routes;